"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BattleLogEntryVfxStepArgs = exports.BattleLogEntrySegment = void 0;
const uuid_1 = require("uuid");
const ActorType_1 = require("../../actors/ActorType");
const enums_1 = require("../../enums");
const DamageTypeToColor_1 = require("../../maps/DamageTypeToColor");
const Round_1 = require("../../utils/Round");
class BattleLogEntrySegment {
    constructor(value, color = "black", size = "medium", family = "roboto", weight = "normal") {
        this.value = value;
        this.color = color;
        this.size = size;
        this.family = family;
        this.weight = weight;
    }
    static damage(damage, crit) {
        const text = `${(0, Round_1.roundTo)(damage.amount, 1)} ${enums_1.DamageType[damage.type]} `;
        return new BattleLogEntrySegment(text, DamageTypeToColor_1.DamageTypeToColor[damage.type], undefined, undefined, crit && "bold" || "normal");
    }
    static actorName(container, actorId, color = "white", size = "medium") {
        const actor = container.getActor(actorId);
        const className = ActorType_1.ActorType[actor === null || actor === void 0 ? void 0 : actor.classType] || "UNKNOWN";
        return new BattleLogEntrySegment(`<${className}|${actorId}>`, color, size);
    }
}
exports.BattleLogEntrySegment = BattleLogEntrySegment;
BattleLogEntrySegment.whitespace = new BattleLogEntrySegment(" ");
class BattleLogEntryVfxStepArgs {
    constructor(segments) {
        this.segments = segments;
        this.__typeName = "BattleLogEntry";
        this.id = (0, uuid_1.v4)();
    }
    static fromDamages(container, attackerId, targetId, crit, damages) {
        // 1:42:44 PM (Warrior|1007) damages (SkeletalMage|1031): (71 Physical)
        const segments = [
            BattleLogEntrySegment.actorName(container, attackerId),
            new BattleLogEntrySegment(" damages "),
            BattleLogEntrySegment.actorName(container, targetId),
            new BattleLogEntrySegment(": "),
        ];
        let sum = 0;
        for (const damage of damages) {
            sum += damage.amount;
        }
        const starOrNot = crit ? "*" : "";
        const weight = crit ? "bold" : "normal";
        segments.push(new BattleLogEntrySegment(` ${starOrNot}${sum}${starOrNot}`, undefined, undefined, undefined, weight));
        segments.push(new BattleLogEntrySegment(" ("));
        for (let i = 0; i < damages.length; i++) {
            if (i > 0) {
                segments.push(BattleLogEntrySegment.whitespace);
            }
            segments.push(BattleLogEntrySegment.damage(damages[i], crit));
        }
        segments.push(new BattleLogEntrySegment(")"));
        return new BattleLogEntryVfxStepArgs(segments);
    }
    static fromAttack(container, attackerId, targetId, attack) {
        // Warrior|1007) attacks (SkeletalMage|1031): hit (1 + 22 = 23)
        const color = attack.crit ? "yellow" : "white";
        const size = attack.crit ? "large" : "medium";
        const weight = attack.crit ? "bold" : "normal";
        const segments = [
            BattleLogEntrySegment.actorName(container, attackerId),
            new BattleLogEntrySegment(" attacks "),
            BattleLogEntrySegment.actorName(container, targetId),
            new BattleLogEntrySegment(`: ${attack.hit ? attack.crit ? "*crit*" : "hit" : "miss"}`, color, size, undefined, weight),
            new BattleLogEntrySegment(` (${(0, Round_1.roundTo)(attack.total, 2)})`)
        ];
        return new BattleLogEntryVfxStepArgs(segments);
    }
    static fromHealing(container, healerId, targetId, amount) {
        const segments = [
            BattleLogEntrySegment.actorName(container, targetId),
            new BattleLogEntrySegment(`: Healed ${(0, Round_1.roundTo)(amount, 1)} Hit Points`)
        ];
        return new BattleLogEntryVfxStepArgs(segments);
    }
}
exports.BattleLogEntryVfxStepArgs = BattleLogEntryVfxStepArgs;
